export default __webpack_public_path__ + "static/media/PPI-pools-025.f2ac3e96.jpg";